(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Static-Categories"] && !Shopify.designMode) return;
  try {
    
// if screen width is below 620px add margin below cat image to match Maintanence Parts button alignment.

  } catch(e) { console.error(e); }
})();
})();
